import React from "react";
import { Box, Grid } from "@mui/material";
import { Skeleton, Stack } from "@mui/material";

const SkeletonCommunication = () => {
  const widthInput = 230;
  const heightInput = 124;
  const widthTextInput = 100;

  return (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
    >
      <Stack
        alignItems="flex-end"
        justifyContent="space-between"
        width="100%"
        direction="column"
        spacing={2}
      >
        <Stack alignItems="flex-end" spacing={1}>
          <Skeleton variant="text" width={widthTextInput} />
          <Skeleton
            variant="rectangular"
            width={widthInput}
            height={heightInput}
          />
        </Stack>
        <Stack alignItems="flex-end" spacing={1}>
          <Skeleton variant="text" width={widthTextInput} />
          <Skeleton
            variant="rectangular"
            width={widthInput}
            height={heightInput}
          />
        </Stack>
        <Stack alignItems="flex-end" spacing={1}>
          <Skeleton variant="text" width={widthTextInput} />
          <Skeleton
            variant="rectangular"
            width={widthInput}
            height={heightInput}
          />
        </Stack>
      </Stack>
    </Box>
  );
};

export default SkeletonCommunication;
